/*global jQuery */
/*
 *  Description: scroll to section, also used to scroll to top
 *  Author: Kim Christiansen
 *
 *  Usage:
 *  <a href="#main" class="js-sectionscroll">To top</a>
 *
 */
( function ($, window) {
  'use strict';

  var $window,
      $document,
      $scope,
      offset = 140,
      init = function () {
        $window = $(window);
        $document = $(document);
        $scope = $('.js-sectionscroll');

        if ($scope.length) {
          $document.on('click', '.js-sectionscroll', function (e) {
            e.preventDefault();
            var $this = $(e.currentTarget);
            var targetId = $this.attr('href');

            targetId = targetId.substr(targetId.indexOf('#'));
            var $target = $(targetId);


            if ($target.length) {
              var targetY = Math.round($target.offset().top)-offset;
            } else {
              var targetY = 0;
            }

            $('html, body').animate({
              scrollTop: targetY
            }, 500);
          });
        }

      };

  init();
}(jQuery, window));
